import React, { useCallback, useState } from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import CalculateIcon from '@material-ui/icons/LocationSearching';

import buttonStyles from './styles';
import { fetchPost } from '../../../Util/fetchAPI';

type Props = {
  path: string;
};

const RecalculateButton = (props: Props) => {
  const buttonClasses = buttonStyles();
  const { path } = props;

  const [calculating, setCalculating] = useState<boolean>(false);
  
  const recalculateBallTracks = useCallback(() => {
    setCalculating(true);
    fetchPost(path).then(() => {
      setCalculating(false);
    });
  }, [path]);
  
  return (
    <React.Fragment>
      <Tooltip title={'Recalculate'} arrow>
        <IconButton
          onClick={recalculateBallTracks}
          className={calculating ? buttonClasses.toggleIconActive : buttonClasses.toggleIcon}>
          <CalculateIcon />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
};

export default RecalculateButton;